const lentaPosts = [
    {
        image: require('./images/lenta/post-animation/1.jpg'),
    },
    {
        image: require('./images/lenta/post-animation/2.jpg'),
    },
    {
        image: require('./images/lenta/post-animation/3.png'),
    },
    {
        image: require('./images/lenta/post-animation/4.jpg'),
    },
];

export default lentaPosts;